import { MenuItem } from "primereact/menuitem";
import { DEFAULT_GUID } from "../../../shared/util/constant";
import { MergeDocDto } from "../../model/MailMergeModel/MergeDocDto";
import { MailMergeRequest } from "../../model/MailMergeRequest";
import MailMergeAPI from '../../services/MailMergeAPI';
import CustomerActivityService from "../../customer-activity/CustomerActivityService";
import { CustomerActivityAddRequest } from "../../model/CustomerActivityAddRequest";
import { LookupDetailConstants } from "../../../shared/util/LookupDetailConstants";

class SliderMailMergeService {

    mergeApi: MailMergeAPI;
    customerActivityService:CustomerActivityService;
    constructor() {
        this.mergeApi = new MailMergeAPI();
        this.customerActivityService = new CustomerActivityService();
    }

    getMergeDocGroup = async (): Promise<any[]> => {
        var data = await this.mergeApi.fetchListOfMailMergeGroup();
        
        let headerMenu: MenuItem[] = [];
        data = data.map((item: any) => {
            item.isItemExpanded = false; // Initialize isItemExpanded
            // Assign id for submenu items
            if (item.items && Array.isArray(item.items)) {
                item.items = item.items.map((subItem: any) => ({
                    ...subItem,
                    id: subItem.id // Set id for submenu item
                }));
            }
            let menuItem: MenuItem = {
                id: item.docGroupId,
                label: item.label,
                data: item,
                items: item.items || []
            };
            headerMenu.push(menuItem);
        });
        return headerMenu;
    }

    getMergeDocument = async (request: MailMergeRequest): Promise<any> => {
        return await this.mergeApi.getMergeDocument(request);
    }

    getInputFields = async (mergeTemplateId: string): Promise<any[]> => {
        return await this.mergeApi.getInputFields(mergeTemplateId);
    }

    createActivityForDocumentGenerated = async (request: MailMergeRequest, documentName : string) => {
        let customerActivityAddRequest : CustomerActivityAddRequest = {
            custId: request.custId,
            activityTypeId: LookupDetailConstants.CUSTOMER_ACTICITY_TYPE.FORM_LETTER,
            policyId: request.policyId || undefined,
            activityEffDate: new Date(),
            description: documentName,
            claimId: undefined
        };

        return await this.customerActivityService.addNewActivity(customerActivityAddRequest);
    }
};

export default SliderMailMergeService;